import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { useDispatch } from 'hooks';
import { isModalOpen } from 'modules/basket/selectors';
import { openBasketModal } from 'modules/basket/actions';

import { getNewAcceptedExtra, getNewAcceptedProactiveWorks } from 'modules/form/selectors';
import Basket from './index';
import Icon from 'components/ui/Icon';
import Button, { ButtonType } from '../ui/Button';

const BasketButton: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const displayModal = useSelector(isModalOpen);
  const newAcceptedExtra = useSelector(getNewAcceptedExtra);
  const newAcceptedProactiveWorks = useSelector(getNewAcceptedProactiveWorks);

  const nbAccepted = newAcceptedExtra.length + newAcceptedProactiveWorks.length;

  const hasMoreThan9Accepted = nbAccepted > 9;
  const nbDisplayedAccepted = Math.min(nbAccepted, 9);

  const handleClick = React.useCallback(() => {
    dispatch(openBasketModal());
  }, [dispatch]);

  return (
    <>
      <Button
        onClick={handleClick}
        testId="basket-button"
        type={ButtonType.SECONDARY}
        className="size-10 kiosk:size-20 !p-2 mr-2 relative flex items-center justify-center btn-header"
        aria-label={intl.formatMessage({ id: 'accessibility.button.basket', defaultMessage: 'Basket with {nbItems, plural, one {# item} other {# items}}' }, { nbItems: nbAccepted })}
      >
        <Icon className="fb-icon--bag text-2xl kiosk:text-4xl"/>
        {nbDisplayedAccepted > 0 && (
        // eslint-disable-next-line max-len
          <div className="absolute right-basket-items-right top-basket-items-top rounded-full border border-default size-s bg-default text-white flex justify-center items-center" aria-hidden="true">
            <span className="text-white text-xxxs -mb-0.5">
              {nbDisplayedAccepted}
              {hasMoreThan9Accepted && '+'}
            </span>
          </div>
        )}
      </Button>
      {displayModal && <Basket />}
    </>
  );
};

export default BasketButton;
